import { MenuAction } from '@shared/interfaces/header/menu-action';
import { Download, Eye, FileSpreadsheet, GitPullRequest } from 'lucide-angular';

export const settlementActionMenu: MenuAction[] = [
    {
      title: 'settlement.actions.view',
      id: 'view',
      icon: Eye,
    },
    {
      title: 'settlement.actions.request',
      id: 'request',
      icon: GitPullRequest,
    },
    {
      title: 'settlement.actions.export',
      id: 'export',
      icon: Download,
    }
  ]

export const settlementWholesaleActionMenu: MenuAction[] = [
    {
      title: 'settlement.actions.view',
      id: 'view',
      icon: Eye,
    },
    {
      title: 'settlement.actions.request',
      id: 'request',
      icon: GitPullRequest,
    },
    {
      title: 'settlement.actions.exportReport',
      id: 'exportReport',
      icon: FileSpreadsheet,
    }
  ]
